import { FeatureFlag } from '@sonar-software/sonar-core';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { PageLayoutDetailsTab, PageLayoutFieldsTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';

export const PageLayoutScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { sonarObjectId, relatedCounts = {} } = data;

	return (
		<PeriscopeMenuTabs>
			<PeriscopeTabArea
				featureFlag={ FeatureFlag.DataDictionary }
				forceRender
				key={ PERISCOPE_TAB_TYPES.DETAILS }
				tab={ PERISCOPE_TAB_TYPES.DETAILS }>
				<PageLayoutDetailsTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceField ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FIELDS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.FIELDS }>
				<PageLayoutFieldsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
